import { useEffect, useState } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import LineGradient from "./components/LineGradient";
import useMediaQuery from "./hooks/useMediaQuery";
import Contact from "./Screens/Contact";
import DotGroup from "./Screens/DotGroup";
import Footer from "./Screens/Footer";
import Landing from "./Screens/Landing";
import MySkills from "./Screens/AboutMe";
import Navbar from "./Screens/Navbar";
import Projects from "./Screens/MySkill";
import Testimonials from "./Screens/ProjectHome";

import Main from "./layout/Main";
import Home from "./Screens/Home";

import AllProjects from "./Screens/AllProjects";
import AllInternProject from "./Screens/AllInternProject";
import Eventsliner from "./Screens/InternProjectDet/Eventsliner";

function App() {

  const router = createBrowserRouter([
    {
      path: '/',
      element: <Main></Main>,
      children: [
        {
          path: '/',
          element: <Home></Home>
        },
        {
          path: '/allprojects',
          element: <AllProjects></AllProjects>
        },
        {
          path: '/eventsliner',
          element: <Eventsliner/>
        },
        {
          path: '/allinternwork',
          element: <AllInternProject/>
        },
        

      ]
    }
  ])



  return (
    <div>
      <RouterProvider router={router}></RouterProvider>
    </div>
  );
}

export default App;